import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import { InputIcon } from "primereact/inputicon";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import debounce from 'lodash/debounce';

//components
import HeaderSearchBar from "../../../Components/UiComponents/HeaderSearch";
import DataTable from "../../../Components/UiComponents/DataTable";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import CreateNewContacts from './AddContact';
import EditContact from './EditContact';
import MultiSelectElement from "../../../Components/UiComponents/MultiSelectElement";
import Loader from "../../../Components/UiComponents/Loader";
// Services
import { getField } from "../../../Services/tooltipService";
import { contactMultiDelete, contactFilter } from "../../../Services/addressService";
import { get } from "../../../Services/customerServices";
import { getBranchUser } from "../../../Services/userService";
import { all } from "../../../Services/clientService";
import { allOrg } from "../../../Services/organisationService";
import { getAssociatedProj, getAssociatedProjOrg } from "../../../Services/opportunityService";
import { getAllAddress } from "../../../Services/addressService";
import SingleSelectElement from "../../../Components/UiComponents/SingleSelectElement";

const Contacts = (props) => {
    const [loading, setLoading] = useState(false);
    const [searchedContactLength, setSearchedContactLength] = useState(0);
    const [contactDetails, setContactDetails] = useState([]);
    const [filterContactDetails, setFilterConactDetails] = useState([]);
    const [position, setPosition] = useState("center");
    const [contactPosition, setContactPosition] = useState("center");
    const [contactVisible, setContactVisible] = useState(false);
    const [fieldDetails, setFieldDetails] = useState([]);
    const [ids, setIds] = useState([]);
    const [deleteContactDialog, setDeleteContactDialog] = useState(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [contactDetail, setContactDetail] = useState([]);
    const [updatedContact, setUpdatedContact] = useState([]);
    const [projectsAssociated, setProjectsAssociated] = useState([]);
    const [projAssoDialog, setProjAssoDialog] = useState(false);
    const [contactSections, setContactSections] = useState([]);
    const [contactFields, setContactFields] = useState([]);
    const [commonFields, setCommonFields] = useState([]);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: -1,
        sortField: "updated_date",
        sortOrder: -1,
    });
    const [searchQuery, setSearchQuery] = useState("");
    const [totalRecords, setTotalRecords] = useState(0);
    const [branchIdFromLS, setBranchIdFromLS] = useState();
    const [userPrivileges, setUserPrivileges] = useState([]);
    const [customer, setCustomer] = useState({});
    const [showDropdown, setShowDropdown] = useState(false);
    const [role, setRole] = useState([]);
    const [businessUnit, setBusinessUnit] = useState([]);
    const [coOrdinator, setCoOrdinator] = useState([]);
    const [idsContact, setIdsContact] = useState([]);
    const [filterAssociated, setFilterAssociated] = useState([]);
    const [filterAssociatedLabel, setFilterAssociatedLabel] = useState([]);
    const [filterRole, setFilterRole] = useState([]);
    const [filterRoleLabel, setFilterRoleLabel] = useState([]);
    const [filterBU, setFilterBU] = useState([]);
    const [filterBULabel, setFilterBULabel] = useState([]);
    const [filterOwner, setFilterOwner] = useState([]);
    const [filterOwnerLabel, setFilterOwnerLabel] = useState([]);
    const [filterStatus, setFilterStatus] = useState([]);
    const [filterStatusLabel, setFilterStatusLabel] = useState([]);
    const [clients, setClients] = useState([]);
    const [organisations, setOrganisations] = useState([]);
    const [filterClient, setFilterClient] = useState([]);
    const [filterOrg, setFilterOrg] = useState([]);
    const [filterAssociatedId, setFilterAssociatedId] = useState([]);
    const [filterAddressId, setFilterAddressId] = useState('');
    const [filterAddress, setFilterAddress] = useState({});
    const [customerShort, setCustomerShort] = useState("");
    const [currentVersion, setCurrentVersion] = useState([]);
    const [deleted, setDeleted] = useState(false)
    const [isLocation, setIsLocation] = useState(false)
    const [filterAddressList, setFilterAddressList] = useState([])
    const [sortField, setSortField] = useState('name');
    const [sortOrder, setSortOrder] = useState(1); // 1 for asc, -1 for desc

    const toastRef = useRef();
    const navigate = useNavigate();

    // State for contact statuses
    const contactStatuses = [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
        { label: "Left the company", value: "Left the company" },
    ];

    // State for filter associated
    const associated = [
        // { label: 'All', value: 'All' },
        { "_id": 1, label: "Client", value: "Client" },
        // { "_id": 2, label: "Organisation", value: "Organisation" },
    ];

    useEffect(() => {
        const enduserStr = localStorage.getItem("enduser");
        if (enduserStr) {
            const enduser = JSON.parse(enduserStr);
            setCustomer(enduser);
            const branch = enduser.branch;
            setBranchIdFromLS(branch);
        } else {
            navigate("/login")
            localStorage.clear()
        }

        var enduser = localStorage.getItem("enduser");
        if (enduser) {
            const tmpPrivilege = JSON.parse(enduser);
            setUserPrivileges(tmpPrivilege);
        }
    }, []);

    useEffect(() => {
        getCustomerField();
        getContactDetails();
        getAllClients();
        getAllOrganisations();
    }, [props?.customerId]);

    useEffect(() => {

        getContactDetails();
    }, [lazyParams]);

    useEffect(() => {
        getCustomerData();
        getCoordinator();
    }, [props?.branch]);

    useEffect(() => {
        getContactDetails();
    }, [
        filterRoleLabel,
        filterBULabel,
        filterStatusLabel,
        filterAssociatedLabel,
        filterOwnerLabel,
        filterAssociatedId,
        filterAddressId
    ]);

    useEffect(() => {
        if (deleted) {
            setDeleted(false);
            setIds([]);
            setUpdatedContact([])
        }
    }, [deleted])

    useEffect(() => {
        if (filterAssociatedId) {
            getAllAddresses(filterAssociatedId)
        }
    }, [filterAssociatedId])

    const getAllAddresses = async (associated_id) => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            var allData = await getAllAddress(props.customerId, associated_id)
            if (allData && allData.data) {
                if (allData.data.message === 'Available') {
                    setIsLocation(true)
                    var filterAddrList = allData.data.address;
                    filterAddrList.unshift({ address_name: "All" });
                    setFilterAddressList(filterAddrList)
                } else {
                    setIsLocation(false)
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    useEffect(() => {
        if (!filterAssociatedLabel.includes("Client")) {
            setFilterClient([]);
        }
        if (!filterAssociatedLabel.includes("Organisation")) {
            setFilterOrg([]);
        }
    }, [filterAssociatedLabel])

    const getCustomerData = async () => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }

            const customerData = await get(props?.customerId);
            setCustomerShort(customerData?.data?.customer_short);
            const allVersions = customerData?.data?.version_maintained
                .filter((item) => item.module_name === "Opportunity")
                .flatMap((item) => item.version_detail);
            if (allVersions) {
                setCurrentVersion(allVersions);
            }
            const roles = [];
            const businessUnits = [];
            customerData?.data?.reference_data.forEach((item) => {
                if (item.option_names === "Roles") {
                    const activeRoles = item.option_choice.filter(
                        (choice) => choice.status === "active"
                    );
                    roles.push(...activeRoles);
                    setRole(roles);
                } else if (item.option_names === "BusinessUnit") {
                    const activeBusinessUnits = item.option_choice.filter(
                        (choice) => choice.status === "active"
                    );
                    businessUnits.push(...activeBusinessUnits);
                    setBusinessUnit(businessUnits);
                }
            });
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getCoordinator = async () => {
        try {
            const enduserStr = localStorage.getItem("enduser");
            if (enduserStr === null && props.customerId === null) {
                
                return;
            }
            const enduser = JSON.parse(enduserStr);
            if (enduser) {
                const coordintor = await getBranchUser(
                    props?.customerId,
                    enduser?.branch?.branch_id
                );
                const clonedData = coordintor?.data?.map((user) => ({
                    ...user,
                    label: `${user.firstname} ${user.surname}`,
                }));
                setCoOrdinator(clonedData);
            } else {
                navigate("/login")
                localStorage.clear()
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getAllClients = async () => {
        try {
            const enduserStr = localStorage.getItem("enduser");
            if (enduserStr === null && props.customerId === null) {
                return;
            }
            const enduser = JSON.parse(enduserStr);
            if (enduser) {
                const clientres = await all(
                    props?.customerId,
                    enduser?.branch,
                    "client_name",
                    1,
                    {},
                    "Other"
                );
                const clients = clientres?.data?.client?.map((cli) => ({
                    ...cli,
                    label: cli.client_name,
                }));

                setClients(clients);
            } else {
                navigate("/login")
                localStorage.clear()
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getAllOrganisations = async () => {
        try {
            const enduserStr = localStorage.getItem("enduser");
            if (enduserStr === null && props.customerId === null) {
                return;
            }
            const enduser = JSON.parse(enduserStr);
            if (enduser) {
                const orgres = await allOrg(props?.customerId, enduser?.branch);
                const organisations = orgres?.data?.organisation.map((org) => ({
                    ...org,
                    label: org.organisation_name,
                }));
                setOrganisations(organisations);
            } else {
                navigate("/login")
                localStorage.clear()
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getCustomerField = async function () {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            if (props?.customerId !== null) {
                const customerDAta = await getField(props?.customerId);
                setFieldDetails(customerDAta.data.cust[0].modules);
                setCommonFields(
                    _.find(customerDAta?.data.cust[0].modules, {
                        module_name: "Common Fields",
                    }).sub_modules[0].fields
                );
                setContactFields(
                    _.find(
                        _.find(customerDAta?.data.cust[0].modules, {
                            module_name: "Address Book",
                        }).sub_modules,
                        { ESG_sub_module_name: "Contacts" }
                    )?.fields
                );
                setContactSections(
                    _.find(
                        _.find(customerDAta?.data.cust[0].modules, {
                            module_name: "Address Book",
                        }).sub_modules,
                        { ESG_sub_module_name: "Contacts" }
                    )?.sections
                );
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getContactDetails = async () => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true);
            setUpdatedContact([]);
            if (props?.customerId !== null) {
                const { first, rows, sortField, sortOrder, pattern } = lazyParams;
                let data = {
                    skip: first,
                    limit: rows,
                    pattern: pattern,
                    sortBy: sortField,
                    orderBy: sortOrder,
                    filter: {
                        associated:
                            filterAssociatedLabel.length !== 0 ? filterAssociatedLabel : [],
                        associated_id:
                            filterAssociatedLabel.length !== 0
                                ? filterAssociatedId.length !== 0
                                    ? filterAssociatedId
                                    : []
                                : [],
                        filterRole: filterRoleLabel.length !== 0 ? filterRoleLabel : [],
                        filterBU: filterBULabel.length !== 0 ? filterBULabel : [],
                        filterOwner: filterOwnerLabel.length !== 0 ? filterOwnerLabel : [],
                        filterStatus: filterStatusLabel.length !== 0 ? filterStatusLabel : [],
                        filterAddr: filterAddressId ? filterAddressId : ''
                    },
                };
                const contacts = await contactFilter(
                    data.skip,
                    data.limit,
                    props?.customerId,
                    data.pattern,
                    searchQuery,
                    data.sortBy,
                    data.orderBy,
                    data?.filter
                );
                setContactDetails(contacts?.data?.contact);
                setTotalRecords(contacts?.data?.count);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };

    const checkingName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.full_name != null && rowData.full_name !== "") {
            return <div onClick={() => rowClick(rowData)} className="form-label-text text-left mr-20 pointer mar-l-5">{rowData.full_name}</div>;
        }
    };

    const checkingRole = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.role != null && rowData.role !== "") {
            return <div>{rowData.role}</div>;
        }
    };

    const checkingMobile = (rowData) => {
        // Check if display name exists and is not empty
        if (
            rowData.team_member_contact != null &&
            rowData.team_member_contact !== ""
        ) {
            return <div>{rowData.team_member_contact}</div>;
        }
    };

    const checkingLocation = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.address_name != null && rowData.address_name !== "") {
            return <div>{rowData.address_name}</div>;
        }
    };

    const checkingEmail = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.email != null && rowData.email !== "") {
            return <div>{rowData.email}</div>;
        }
    };

    const checkingOffice = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.office_contact != null && rowData.office_contact !== "") {
            return <div>{rowData.office_contact}</div>;
        }
    };

    const checkingAssociated = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.associated != null && rowData.associated !== "") {
            return <div>{rowData.associated}</div>;
        }
    };

    const checkingAssociatedName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.associated_name != null && rowData.associated_name !== "") {
            return <div>{rowData.associated_name}</div>;
        }
    };

    const handleCheck = async (event) => {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setVisibleEdit(false)
            setLoading(true);
            if (event?.associated === "Client") {
                const projAssociation = await getAssociatedProj(
                    props?.customerId,
                    event?.associated_id,
                    event?._id
                );
                if (projAssociation && projAssociation.data.success) {
                    if (projAssociation.data.result.length > 0) {
                        setProjectsAssociated(projAssociation.data.result);
                        setProjAssoDialog(true);
                    } else {
                        toastRef.current.showToast({
                            type: "error",
                            message: `Contact not associated with any project`,
                        });
                    }
                }

            } else if (event?.associated === "Organisation") {
                const projAssociation = await getAssociatedProjOrg(
                    props?.customerId,
                    event?._id
                );
                if (projAssociation && projAssociation.data.success) {
                    if (projAssociation.data.result.length > 0) {
                        setProjectsAssociated(projAssociation.data.result);
                        setProjAssoDialog(true);
                    } else {
                        toastRef.current.showToast({
                            type: "error",
                            message: `Organisation not associated with any project`,
                        });
                    }
                }
            } else {
                toastRef.current.showToast({
                    type: "error",
                    message: `Contact not associated with any project`,
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };

    const checkingAssociation = (rowData) => {
        // Check if display name exists and is not empty
        // if (rowData?.associated != null && rowData.associated !== "") {
        //     return <div>{rowData.associated}</div>;
        // }
        return (
            <div>
                <InputIcon
                    className={"pi pi-book"}
                    style={{ color: "blue" }}
                    onClick={() => handleCheck(rowData)}
                />
            </div>
        );
    };
    const checkingBusiness = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData?.business_unit != null && rowData.business_unit !== "") {
            return <div>{rowData.business_unit}</div>;
        }
    };

    const checkingOrdinate = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData?.owner != null && rowData?.owner !== "") {
            return <div>{rowData.owner}</div>;
        }
    };

    const checkingwebsite = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.website != null && rowData.website !== "") {
            const truncatedComment =
                rowData.website.length > 7
                    ? rowData.website.substring(0, 7) + "..."
                    : rowData.website;
            return <Link to={`https://${rowData.website}`}>{truncatedComment}</Link>;
        }
    };

    const checkingComments = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.comment != null && rowData.comment !== "") {
            const truncatedComment =
                rowData.comment.length > 7
                    ? rowData.comment.substring(0, 7) + "..."
                    : rowData.comment;
            return <div>{truncatedComment}</div>;
        }
    };

    const checkingStatus = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData?.status != null && rowData?.status !== "") {
            return <div>{rowData.status}</div>;
        }
    };

    const nameTemplate = () => {
        return _.find(commonFields, { field_name: "Name" })?.display_name;
    };

    const roleTemplate = () => {
        return _.find(commonFields, { field_name: "Role" })?.display_name;
    };

    const mobileTemplate = () => {
        return _.find(contactFields, { field_name: "Mobile Number" })?.display_name;
    };

    const officeTemplate = () => {
        return _.find(commonFields, { field_name: "Office Number" })?.display_name
    }

    const emailTemplate = () => {
        return _.find(contactFields, { field_name: "Email" })?.display_name;
    };

    const projectTemplate = () => {
        return _.find(contactFields, { field_name: "Project Association" })
            ?.display_name;
    };

    const projectAssociatedTemplate = () => {
        return _.find(commonFields, { field_name: "Associated to" })?.display_name;
    };

    const associatedNameTemplate = () => {
        return _.find(commonFields, { field_name: "Associated Name" })
            ?.display_name;
    };

    const locationTemplate = () => {
        return _.find(commonFields, { field_name: "Location Name" })?.display_name;
    };

    const buTemplate = () => {
        return _.find(commonFields, { field_name: "Business Unit" })?.display_name;
    };

    const coordinatorTemplate = () => {
        return _.find(contactFields, { field_name: "Co-ordinator" })?.display_name;
    };

    const websiteTemplate = () => {
        return _.find(contactFields, { field_name: "Website" })?.display_name;
    };

    const commentsTemplate = () => {
        return _.find(contactFields, { field_name: "Comments" })?.display_name;
    };

    const statusTemplate = () => {
        return _.find(contactFields, { field_name: "Status" })?.display_name;
    };

    const column = [
        // Column configuration for the "Question" field
        {
            field: 'full_name', // Data field to map from the row data
            header: nameTemplate, // Header label for the column
            body: checkingName, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: 'role', // Data field to map from the row data
            header: roleTemplate, // Header label for the column
            body: checkingRole, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "team_member_contact", // Data field to map from the row data
            header: mobileTemplate, // Header label for the column
            body: checkingMobile, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "office_contact", // Data field to map from the row data
            header: officeTemplate, // Header label for the column
            body: checkingOffice, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "email", // Data field to map from the row data
            header: emailTemplate, // Header label for the column
            body: checkingEmail, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "Project Association", // Data field to map from the row data
            header: projectTemplate, // Header label for the column
            body: checkingAssociation, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            // sortable: true,
        },
        {
            field: "associated", // Data field to map from the row data
            header: projectAssociatedTemplate, // Header label for the column
            body: checkingAssociated, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "associated_name", // Data field to map from the row data
            header: associatedNameTemplate, // Header label for the column
            body: checkingAssociatedName, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "address_name", // Data field to map from the row data
            header: locationTemplate, // Header label for the column
            body: checkingLocation, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "business_unit", // Data field to map from the row data
            header: buTemplate, // Header label for the column
            body: checkingBusiness, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "owner", // Data field to map from the row data
            header: coordinatorTemplate, // Header label for the column
            body: checkingOrdinate, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "website", // Data field to map from the row data
            header: websiteTemplate, // Header label for the column
            body: checkingwebsite, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "comment", // Data field to map from the row data
            header: commentsTemplate, // Header label for the column
            body: checkingComments, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
        {
            field: "status", // Data field to map from the row data
            header: statusTemplate, // Header label for the column
            body: checkingStatus, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
            sortable: true,
        },
    ];

    const filteredQuestionsArray = (query) => {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            // If the query is empty, retrieve the full customer field data
            getContactDetails();
            setSearchedContactLength(lowerCaseQuery.length); // Update the searched length after resetting the data
        } else {
            if (lowerCaseQuery.length > searchedContactLength) {
                setSearchedContactLength(lowerCaseQuery.length);
            } else {
                setSearchedContactLength(lowerCaseQuery.length);
            }

            // Filter the customer reference data if the query is not empty
            const filteredData = filterContactDetails.filter((item) => {
                // Check if any value in the item includes the query string
                return Object.values(item).some((value) => {
                    // Convert value to string and to lowercase for comparison
                    return value.toString().toLowerCase().includes(lowerCaseQuery);
                });
            });
            // Update the state with the filtered data
            //   setContactDetails(filteredData);
        }
    };

    const handleHide = () => {
        setContactVisible(false);
        getContactDetails();
        setVisibleEdit(false);
    };

    const show = (position) => {
        setContactPosition(position);
        setContactVisible(true);
    };

    const removeFieldContact = async (selectedIndex, data) => {
        const ids = [];
        data.forEach((item) => {
            ids.push(item._id);
        });
        setIdsContact(ids);
        setUpdatedContact(data);
    };

    const deleteContact = async () => {
        try {
            setLoading(true);
            // const deleteResponse = await contactMultiDelete(idsContact);
            await contactMultiDelete(idsContact).then(response => {
                var namesList = updatedContact.map((item) => item.full_name).join(", ");
                setUpdatedContact([]);
                if (response.data.success) {
                    setUpdatedContact([]);
                    setDeleted(true)
                    toastRef.current.showToast({
                        type: "success",
                        message: response.data.message
                    });

                } else {
                    toastRef.current.showToast({
                        type: "error",
                        message: response.data.message
                    });
                }
                hideDeleteContactDialog();
                getContactDetails();
            })

        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };

    const confirmDeleteContact = () => {
        setDeleteContactDialog(true);
    };

    const hideDeleteContactDialog = () => {
        setDeleteContactDialog(false);
        setUpdatedContact([]);
        // window.location.reload()
    };

    const deleteContactDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className="align-center justify-end pb-0">
                    <ButtonElement
                        label="No"
                        className="cancel-new-button"
                        onClick={hideDeleteContactDialog}
                    />
                    <ButtonElement
                        type="submit"
                        label="Yes"
                        className="save-button"
                        onClick={deleteContact}
                    />
                </div>
            </div>
        );
    };

    const projAssoDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className="align-center justify-end pb-0">
                    <ButtonElement
                        label="Close"
                        className="cancel-new-button"
                        onClick={hideProjAssoDialogDialog}
                    />
                </div>
            </div>
        );
    };

    const hideProjAssoDialogDialog = () => {
        setProjAssoDialog(false);
    };

    const showEdit = (position) => {
        if (!projAssoDialog) {
            setPosition(position);
            setVisibleEdit(true);
        }
    };

    const rowClick = async (data) => {
        if (data?.first_name) {
            setContactDetail(data);
            showEdit();
        }
    };

    const onPage = (event) => {
        setLazyParams({
            ...lazyParams,
            first: event.first,
            rows: event.rows,
            page: event.page,
        });
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e);
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0,
        });
        // filteredQuestionsArray(e);

    };

    const handleClearFilter = () => {
        setSearchQuery("");
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0,
        });
        // filteredQuestionsArray("");

    };

    const resetFilter = () => {
        setSearchQuery("");
        setShowDropdown(false);
        setFilterAssociated([]);
        setFilterAssociatedLabel([]);
        setFilterRole([]);
        setFilterRoleLabel([]);
        setFilterBU([]);
        setFilterBULabel([]);
        setFilterOwner([]);
        setFilterOwnerLabel([]);
        setFilterStatus([]);
        setFilterStatusLabel([]);
        setFilterClient([]);
        setFilterOrg([]);
        setFilterAssociatedId([]);
        setFilterAddress({});
        setFilterAddressId('');
        setShowDropdown(false)
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const handleSelection = (event) => {
        setFilterRole(event);
        // Extract the _id values from the selected branches
        const ids = event.map((item) => item?.label);
        setFilterRoleLabel(ids);
    };
    const handleBUSelection = (event) => {
        setFilterBU(event);
        // Extract the _id values from the selected branches
        const ids = event.map((item) => item?.label);
        setFilterBULabel(ids);
    };

    const handleCOSelection = (event) => {
        setFilterOwner(event);
        // Extract the _id values from the selected branches
        const ids = event.map((item) => item?.label);
        setFilterOwnerLabel(ids);
    };

    const handleStatusSelection = (event) => {
        setFilterStatus(event);
        setFilterStatusLabel(event);
    };

    const handleAssociatedSelection = (event) => {
        setFilterAssociated(event.selectedOption._id);
        setFilterAssociatedLabel(event.value);
        if (event.length === 0) {
            setFilterAssociatedId([]);
        }
    };

    const handleClientSelection = (event) => {
        setFilterClient(event);
        const ids = event.map((item) => item?._id);
        setFilterAssociatedId(ids);
    };

    const handleOrgSelection = (event) => {
        setFilterOrg(event);
        const ids = event.map((item) => item?._id);
        setFilterAssociatedId(ids);
    };

    const handleLocationSelection = function (event) {
        setFilterAddress(event);
        setFilterAddressId(event.address_name);
    }

    const oppRedirect = (id, opportunity_name) => {
        if (userPrivileges[0].opp_edit) {
            setProjAssoDialog(false);
            setVisibleEdit(false);
            const current_version = currentVersion?.filter(
                (version) => version.checked
            );
            if (id) {
                navigate(`/portfolio/${id}/${customerShort}/${current_version[0].folder}`, { state: { opportunityName: opportunity_name, opportunity_id: id } });
            }
        } else {
            toastRef.current.showToast({
                type: "error",
                message: `myConsole Permission Denied`,
            });
        }
    };

    const onSort = (e) => {
        let newSortField = e.sortField;
        let newSortOrder = e.sortOrder;

        // Check if the same column is clicked
        if (lazyParams.sortField === newSortField) {
            // If currently sorted ascending, switch to descending
            if (lazyParams.sortOrder === 1) {
                newSortOrder = -1; // Set to descending
            }
            // If currently sorted descending, remove sorting
            else if (lazyParams.sortOrder === -1) {
                newSortField = 'updated_date'; // Remove sorting
                newSortOrder = -1; // Remove sorting
            }
        }
        setLazyParams((prevParams) => ({
            ...prevParams,
            sortField: newSortField,
            sortOrder: newSortOrder,
        }));
    };

    const dropdownRef = useRef(null);
    const handleOutsideClick = (event) => {
        if (showDropdown) {
            const target = event.target;
            const dropdownButton = document.querySelector('.clear-filter-button');
            const dropdownContent = document.querySelector('.s-field');
            const multiSelectInput = document.querySelector('.p-multiselect-filter');
    
            if (
                !dropdownContent.contains(target) && 
                target !== dropdownButton && 
                target !== multiSelectInput &&
                !target.closest('.p-multiselect-item') 
            ) {
                setShowDropdown(false);
            }
        }
    };


    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [showDropdown]);


    return (
        <div className="mt-10">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />

            <div className="group-table-component">
                <div className="group-table-buttons">
                    <div className="d-flex">
                        <div className="delete-button">
                            {updatedContact.length > 0 && (
                                <ButtonElement
                                    className="delete-button-icon"
                                    type="button"
                                    icon="pi pi-trash"
                                    onClick={() => confirmDeleteContact()}
                                />
                            )}
                        </div>
                    </div>
                    <div className="group-table-search">
                        <HeaderSearchBar
                            value={searchQuery}
                            onChange={(e) => handleSearchChange(e)}
                            onClick={handleClearFilter}
                        />
                        <ButtonElement
                            className="clear-filter-button"
                            icon="pi pi-filter-slash"
                            onClick={resetFilter}
                        />
                        <div className="p-relative" ref={dropdownRef}>
                            <ButtonElement
                                className="clear-filter-button"
                                icon="pi pi-filter"
                                onClick={toggleDropdown}
                            />
                            {showDropdown && (
                                <>
                                    <div className="s-field">
                                        <div className="new-field w-100">
                                            {
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Role:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={filterRole}
                                                            optionLabel="label"
                                                            options={role}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Business Unit:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={filterBU}
                                                            optionLabel="label"
                                                            options={businessUnit}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleBUSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                <div className="col-md-5 pl-0">
                                                    <label className="form-label text-left">
                                                        Co-ordinator:
                                                    </label>
                                                </div>
                                                <div className="col pr-0">
                                                    <MultiSelectElement
                                                        value={filterOwner}
                                                        optionLabel="label"
                                                        options={coOrdinator}
                                                        placeholder="-- Please select --"
                                                        maxSelectedLabels={1}
                                                        onChangeValue={(e) => handleCOSelection(e.value)}
                                                        className="w-full"
                                                    />
                                                </div>
                                            </div>
                                            {
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Status:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={filterStatus}
                                                            optionLabel="label"
                                                            options={contactStatuses}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) =>
                                                                handleStatusSelection(e.value)
                                                            }
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Associated To:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={filterAssociatedLabel}
                                                            optionLabel="label"
                                                            options={associated}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) =>
                                                                handleAssociatedSelection(e)
                                                            }
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {filterAssociatedLabel.includes("Client") && (
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Client:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={filterClient}
                                                            optionLabel="label"
                                                            options={clients}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) =>
                                                                handleClientSelection(e.value)
                                                            }
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {filterAssociatedLabel.includes("Organisation") && (
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Organisations:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={filterOrg}
                                                            optionLabel="label"
                                                            options={organisations}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleOrgSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {
                                                isLocation &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Location Name:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <SingleSelectElement
                                                            value={filterAddress}
                                                            optionLabel="address_name"
                                                            options={(filterAddressList != undefined && filterAddressList.length > 0) ? filterAddressList : []}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleLocationSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        {!customer.isRestricted && (
                            <ButtonElement
                                className="clear-filter-button"
                                type="button"
                                icon="pi pi-plus"
                                label="New"
                                onClick={() => show("right")}
                            />
                        )}
                    </div>
                </div>
                <DataTable
                    value={contactDetails}
                    columns={column}
                    searchQuery={searchQuery}
                    removeField={removeFieldContact}
                    dataKey="_id"
                    isPrompts={true}
                    onPage={onPage}
                    lazyParams={lazyParams}
                    totalRecords={totalRecords}
                    deleted={deleted}
                    onSort={onSort}
                />
            </div>
            <CreateNewContacts
                visible={contactVisible}
                position={"right"}
                customerId={props?.customerId}
                onHide={handleHide}
                fieldDetails={fieldDetails}
                clientSectionsSummary={contactSections}
                commonFields={commonFields}
                addressContactFields={contactFields}
                branch={branchIdFromLS}
                coordinatorList={coOrdinator}
            />
            <EditContact
                visible={visibleEdit}
                position={'right'}
                customerId={props?.customerId}
                contactDetail={contactDetail}
                onHide={handleHide}
                fieldDetails={fieldDetails}
                clientSectionsSummary={contactSections}
                commonFields={commonFields}
                addressContactFields={contactFields}
                branch={branchIdFromLS}
            />
            <Dialog
                visible={deleteContactDialog}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header="Delete Contact"
                modal
                footer={deleteContactDialogFooter()}
                onHide={hideDeleteContactDialog}
                className="table-dialog width-32"
                draggable={false}
            >
                <div className="confirmation-content">
                    <span className="table-description">
                        Are you sure to delete the contact(s)?
                    </span>
                </div>
            </Dialog>
            <Dialog
                visible={projAssoDialog}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header="Projects Associated"
                modal
                footer={projAssoDialogFooter()}
                onHide={hideProjAssoDialogDialog}
                className="table-dialog width-32"
                draggable={false}
            >
                <div className="confirmation-content">
                    <span className="table-description">
                        {projectsAssociated.length > 0 &&
                            projectsAssociated.map((pro, index) => (
                                <li key={pro._id || index}>
                                    <a
                                        className="form-label-text text-left mr-20 pointer"
                                        onClick={() => oppRedirect(pro._id, pro.opportunity_name)}
                                    >
                                        {pro.opportunity_name}
                                    </a>
                                </li>
                            ))}
                    </span>
                </div>
            </Dialog>
        </div>
    );
};

export default Contacts;